import { NOT_IN_STORE } from '../constants/ActionTypes';
import { baseUrl } from '../constants/baseUrl';

export const updateShopBusyAction = (paramObj, onSuccess, onFailure) => ({
    type: NOT_IN_STORE,
    payload: paramObj,
    meta: {
        type: 'api',
        url: baseUrl + '/update_shop_busy',
        onSuccess: onSuccess,
        onFailure: onFailure,
        params: {
            shop_id: paramObj.shopId,
            is_busy: paramObj.isBusy,
        },
        options: {
            method: 'GET'
        }
    }
}); 